import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

const UpsellFBESoonCardContent = ({ accessExpirationDate, timezoneFormatArgs }) => {
  const { formatMessage, formatDate } = useIntl();
  const includingAnyProgress = (
    <span className="font-weight-bold">
      {formatMessage({
        id: 'advertisements.upgradeNotification.expirationAccessLoss.progress',
        defaultMessage: 'including any progress',
        description: 'Bolded text inside of the access loss bullet point',
      })}
    </span>
  );

  const date = formatDate(
    new Date(accessExpirationDate),
    {
      key: 'accessDate',
      day: 'numeric',
      month: 'long',
      ...timezoneFormatArgs,
    },
  );

  const benefitsOfUpgrading = (
    <a className="inline-link-underline font-weight-bold" rel="noopener noreferrer" target="_blank" href="https://support.edx.org/hc/en-us/articles/360013426573-What-are-the-differences-between-audit-free-and-verified-paid-courses-">
      {formatMessage({
        id: 'advertisements.upgradeNotification.expirationVerifiedCert.benefits',
        defaultMessage: 'benefits of upgrading',
        description: 'Text for link to edX support website',
      })}
    </a>
  );

  return (
    <div className="upgrade-notification-text">
      <p>
        {formatMessage(
          {
            id: 'advertisements.upgradeNotification.expirationAccessLoss',
            defaultMessage: 'You will lose all access to this course, {includingAnyProgress}, on {date}.',
            description: 'Text for access loss bullet point',
          },
          { includingAnyProgress, date },
        )}
      </p>
      <p>
        {formatMessage(
          {
            id: 'advertisements.upgradeNotification.expirationVerifiedCert',
            defaultMessage: 'Upgrading your course enables you to pursue a verified certificate and unlocks numerous features. Learn more about the {benefitsOfUpgrading}.',
            description: 'Text for verified certificate bullet point',
          },
          { benefitsOfUpgrading },
        )}
      </p>
    </div>
  );
};

UpsellFBESoonCardContent.propTypes = {
  accessExpirationDate: PropTypes.PropTypes.instanceOf(Date).isRequired,
  timezoneFormatArgs: PropTypes.shape({
    timeZone: PropTypes.string,
  }),
};

UpsellFBESoonCardContent.defaultProps = {
  timezoneFormatArgs: {},
};

export default UpsellFBESoonCardContent;
